export const Minus = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19.3125 12C19.3125 12.4922 18.9258 12.8438 18.4688 12.8438H5.53125C5.03906 12.8438 4.6875 12.4922 4.6875 12.0352C4.6875 11.543 5.03906 11.1562 5.53125 11.1562H18.4688C18.9258 11.1562 19.3125 11.543 19.3125 12Z" fill="#101828" />
</svg>;
